import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-transaction-fullrefund-modal-shared",
  templateUrl: "./transaction-fullrefund-modal-shared.component.html",
  styleUrls: ["./transaction-fullrefund-modal-shared.component.scss"],
})
export class TransactionFullrefundModalSharedComponent implements OnInit {
  @Input() refundModalPageTwo: any;
  @Input() voidModalPageTwo: any;
  @Input() refundOptions: String[];
  @Input() globalAmount: any;
  @Input() refundReason: any;
  @Input() noteReason: any;
  @Input() cRefundModalPageTwo:any;
  @Input() pRefundModalPageTwo:any;
  @Output() changeRefundReason: EventEmitter<any> = new EventEmitter();
  @Output() changeRefundReasonNote: EventEmitter<any> = new EventEmitter();

  @Output() changeCRefundReason: EventEmitter<any> = new EventEmitter();
  @Output() changeCRefundReasonNote: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}
  changeRefundReasonFunc(event: any) {
    this.changeRefundReason.emit(event);
    // console.log("Full-REF-MODAL-OPEN", this.changeRefundReason)
  }
  changeRefundReasonNoteFunc(event: any) {
    this.changeRefundReasonNote.emit(event);
  }

  changeCRefundReasonFunc(event: any) {
    this.changeCRefundReason.emit(event);
  }
  changeCRefundReasonNoteFunc(event: any) {
    this.changeCRefundReasonNote.emit(event);
  }
}
